<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { logout } from '@/utils/auth';
import { isMasterFull } from '@/utils/auth';
import { useRoute } from 'vue-router';

import router from './router';

// LÓGICA DO LINK MÁGICO
// LÓGICA DO LINK MÁGICO
// LÓGICA DO LINK MÁGICO
// LÓGICA DO LINK MÁGICO
const showModal = ref(true);
const route = useRoute();
const isAdmin = computed(() => {
  route.fullPath;
  return isMasterFull();
});

const closeModal = () => {
  showModal.value = false;
};


const handleUnload = () => {
  logout();

  router.push('/');
};

onMounted(() => {
  window.addEventListener('beforeunload', handleUnload);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleUnload);
});

</script>

<template>
  <div class="visualizacao">
    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <h2 class="my-5">ATENÇÃO</h2>
        <ul>
          <li>Jamais abra mais de uma aba ao mesmo tempo.</li>
          <li>Siga o fluxo do agendamento, um por um, pois caso tente fazer mais de um ao mesmo tempo abrindo novas
            abas, o seu agendamento não será concluído e será excluído.</li>
          <li>Em caso de dúvidas, entre em contato com o suporte.</li>
        </ul>
        <button class="w-50 mx-auto my-5" @click="closeModal">ENTENDI</button>
      </div>
    </div>
    <div style="background-color: #312f30;">
      <div class="container p-5 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-md-3 my-2 d-flex gap-3 flex-column align-items-center align-items-md-start">
            <img style="width:200px" src="https://museucatavento.org.br/sistema-agendamento/logo-catavento-negativa.png"
              alt="" />
            <p class="text-light"><b>Versão 2.1</b></p>
          </div>
          <div class="col-12 col-md-9 my-2">
            <nav class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
              <router-link to="/">Início</router-link>
              <router-link to="/roteirospublic">Agendamento</router-link>
              <router-link to="/registros">Seus agendamentos</router-link>
              <a href="https://museucatavento.org.br/">Site do Museu</a>
              <div class="d-flex gap-5">
                <router-link v-if="isAdmin" title="Administrar Roteiros" to="/roteirosadmin"><svg
                    xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-boxes"
                    viewBox="0 0 16 16">
                    <path
                      d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
                  </svg></router-link>
                <router-link v-if="isAdmin" title="Administrar agendamentos" to="/registros2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-calendar3"
                    viewBox="0 0 16 16">
                    <path
                      d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                    <path
                      d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                  </svg>
                </router-link>
                <router-link v-if="isAdmin" title="Justificativas de cancelamento" to="/cancelamentos">
                  Cancelamentos
                </router-link>
                <button title="sair"
                  style="background-color: transparent;border:none; color:white;text-decoration: underline;font-weight: bold;font-size: 16px;"
                  @click="handleUnload()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff"
                    class="bi bi-arrow-bar-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5" />
                  </svg>
                </button>

              </div>
            </nav>
          </div>
        </div>

      </div>

    </div>


    <router-view />



    <div class="container-fluid p-5" style="background-color: #312f30;">
      <nav class="my-5 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
        <router-link to="/">Início</router-link>
        <router-link to="/roteirospublic">Agendamento</router-link>
        <router-link to="/registros">Seus agendamentos</router-link>
        <a href="https://museucatavento.org.br/">Site do Museu</a>
        <router-link v-if="isAdmin" title="Administrar Roteiros" to="/roteirosadmin"><svg
            xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-boxes"
            viewBox="0 0 16 16">
            <path
              d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
          </svg></router-link>
        <router-link v-if="isAdmin" title="Administrar agendamentos" to="/registros2">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-calendar3"
            viewBox="0 0 16 16">
            <path
              d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
            <path
              d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
          </svg>
        </router-link>
        <router-link v-if="isAdmin" title="Justificativas de cancelamento" to="/cancelamentos">
          Cancelamentos
        </router-link>
        <button title="sair"
          style="background-color: transparent;border:none; color:white;text-decoration: underline;font-weight: bold;font-size: 16px;"
          @click="handleUnload()">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-arrow-bar-right"
            viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5" />
          </svg>
        </button>
        <a class="ajuda" href="https://wa.me/5511993023130">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp"
            viewBox="0 0 16 16">
            <path
              d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
          </svg>
          Fale Conosco</a>
      </nav>
      <div class="row">
        <div class="col-12">
          <p class="text-center" style="color:white">Desenvolvido por: <a href="https://inovahouse.com.br/"
              style="color: white;">Inova House</a></p>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss">
body,
html {
  max-width: 100vw;
  overflow-x: hidden;
  background: #f5f7fa;
}

#app {
  --catavento-dark: #312f30;
  --catavento-blue: #165a96;
  --catavento-orange: #cd5f3f;
  --catavento-text: #243447;
  --catavento-muted: #667085;
  --catavento-border: #d9e1ea;
  --catavento-surface: #ffffff;
  --catavento-radius: 8px;
  --catavento-shadow: 0 10px 28px rgba(20, 30, 45, 0.12);
  font-family: 'Work Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--catavento-text);
  min-height: 100vh;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

 

  .container-fluid {
    width: 100%;
  }

  #contador {
    position: fixed;
    left: 10px;
    bottom: 10px;
    background-color: black;
    color: white;
    padding: 20px;
  }

  h1 {
    color: var(--catavento-blue);
    font-size: clamp(1.85rem, 2.6vw, 2.35rem);
    line-height: 1.15;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  h2,
  h3,
  h4,
  h5 {
    line-height: 1.2;
    color: var(--catavento-text);
  }

  p {
    line-height: 1.55;
  }

  input,
  select,
  textarea {
    width: 100%;
    min-height: 42px;
    border: 1px solid var(--catavento-border);
    border-radius: 6px;
    padding: 0.6rem 0.75rem;
    color: var(--catavento-text);
    background-color: #fff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  textarea {
    min-height: 96px;
    resize: vertical;
  }

  input[type="checkbox"],
  input[type="radio"] {
    width: auto;
    min-height: auto;
    flex: 0 0 auto;
    margin-top: 0.25rem;
  }

  input:focus,
  select:focus,
  textarea:focus {
    border-color: var(--catavento-blue);
    box-shadow: 0 0 0 0.2rem rgba(22, 90, 150, 0.14);
    outline: none;
  }

  label {
    color: var(--catavento-text);
  }

  .btn,
  button {
    border-radius: 6px;
    font-weight: 700;
  }

  .btn {
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    white-space: normal;
  }

  mark {
    border-radius: 4px;
    padding: 0.15rem 0.35rem;
  }

  #desconectar {
    border: none;
    background: none;
    text-decoration: underline;
    cursor: pointer;
    color: white;
  }

  .visualizacao {

    img {
      object-fit: contain;
      width: 250px;
    }

  }

  .ajuda {
    position: fixed;
    right: 16px;
    text-decoration: none;
    bottom: 16px;
    color: black;
    background-color: white;
    border: 2px solid black;
    padding: 10px 14px;
    border-radius: 999px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
    z-index: 20;

    &:hover {
      color: white;
      background-color: black;
    }
  }

}

nav {


  a {
    font-weight: bold;
    color: white;
    font-size: 16px;

    &.router-link-exact-active,
    &:hover {
      color: #cd5f3f;
    }
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  padding: 1rem;
}

.modal-content {
  background: white;
  width: min(680px, 100%);
  max-width: 100%;
  padding: clamp(2rem, 8vw, 5rem) clamp(1rem, 4vw, 2rem);
  border-radius: var(--catavento-radius);
  box-shadow: var(--catavento-shadow);
  text-align: center;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.modal-content ul {
  text-align: left;
  margin-bottom: 20px;
}

.modal-content button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal-content button:hover {
  background-color: #0056b3;
}

@media (max-width: 767px) {
  #app {
    text-align: left;

    .container,
    .container-fluid {
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }

    .visualizacao {
      text-align: center;
    }

    .ajuda {
      left: 1rem;
      right: 1rem;
      bottom: 0.75rem;
      justify-content: center;
      text-align: center;
    }
  }

  nav {
    width: 100%;

    a,
    button {
      min-height: 36px;
    }
  }
}
</style>
